import QuickActions from './QuickActions';
import AttendanceSummary from './AttendanceSummary';
import ProcessStatistics from './ProcessStatistics';
import OrganizationOverview from './OrganizationOverview';
import RecentlyVisited from './RecentlyVisited';
import DateTime from './DateTime';
import AttendanceLiveMonitor from './AttendanceLiveMonitor';
import AccessControlOverview from './AccessControlOverview';
import AttendanceGeofences from './AttendanceGeofences';
import RecentAuditLogs from './RecentAuditLogs';
import TodayBirthday from './TodayBirthday';
import UpcomingEvents from './UpcomingEvents';
import MyPendingTasks from './MyPendingTasks';
import ProcessApprovalQueue from './ProcessApprovalQueue';
import AttendanceApprovalQueue from './AttendanceApprovalQueue';
import ProcessSLAStatus from './ProcessSLAStatus';
import RecentProcessActivity from './RecentProcessActivity';
import IntegrationsOverview from './IntegrationsOverview';
import PendingGdprDeletions from './PendingGdprDeletions';

export interface DashboardWidgetProps {
  licensedProducts?: readonly string[];
}

const widgetComponents: { [key: string]: React.ComponentType<DashboardWidgetProps> } = {
  'quick-actions': QuickActions,
  'attendance-summary': AttendanceSummary,
  'process-statistics': ProcessStatistics,
  'organization-overview': OrganizationOverview,
  'recently-visited': RecentlyVisited,
  'date-time': DateTime,
  'attendance-live-monitor': AttendanceLiveMonitor,
  'access-control-overview': AccessControlOverview,
  'attendance-geofences': AttendanceGeofences,
  'recent-audit-logs': RecentAuditLogs,
  'today-birthday': TodayBirthday,
  'upcoming-events': UpcomingEvents,
  'my-pending-tasks': MyPendingTasks,
  'process-approval-queue': ProcessApprovalQueue,
  'attendance-approval-queue': AttendanceApprovalQueue,
  'process-sla-status': ProcessSLAStatus,
  'recent-process-activity': RecentProcessActivity,
  'integrations-overview': IntegrationsOverview,
  'pending-gdpr-deletions': PendingGdprDeletions,
};

export default widgetComponents;
export { default as AttendanceSummary } from './AttendanceSummary';
export { default as DateTime } from './DateTime';
export { default as OrganizationOverview } from './OrganizationOverview';
export { default as ProcessStatistics } from './ProcessStatistics';
export { default as QuickActions } from './QuickActions';
export { default as RecentlyVisited } from './RecentlyVisited';
export { default as AttendanceLiveMonitor } from './AttendanceLiveMonitor';
export { default as SystemAccessOverview } from './AccessControlOverview';
export { default as AttendanceGeofences } from './AttendanceGeofences';
export { default as RecentSystemLogs } from './RecentAuditLogs';
export { default as TodayBirthday } from './TodayBirthday';
export { default as MyPendingTasks } from './MyPendingTasks';
export { default as ProcessApprovalQueue } from './ProcessApprovalQueue';
export { default as AttendanceApprovalQueue } from './AttendanceApprovalQueue';
export { default as ProcessSLAStatus } from './ProcessSLAStatus';
export { default as RecentProcessActivity } from './RecentProcessActivity';
export { default as IntegrationsOverview } from './IntegrationsOverview';
export { default as PendingGdprDeletions } from './PendingGdprDeletions';